<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Редактирование профиля
            </div>

            <div class="subtitle-1 font-weight-light">
              Заполните свой профиль
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Имя"
                    class="purple-input"
                    v-model="data.firstName"
                    :error-messages="errors['firstName'] || []"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Фамилия"
                    class="purple-input"
                    v-model="data.lastName"
                    :error-messages="errors['lastName'] || []"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Email"
                    class="purple-input"
                    v-model="data.email"
                    :error-messages="errors['email'] || []"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Телефон"
                    class="purple-input"
                    v-model="data.phoneNumber"
                    :error-messages="errors['phoneNumber'] || []"
                  />
                </v-col>

                <v-col
                  v-if="needConfirmPhoneNumber"
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Введить код из смс"
                    class="purple-input"
                    v-model="data.token"
                    :error-messages="errors['token'] || []"
                  />
                </v-col>

              </v-row>
            </v-container>
          </v-form>
          <div class="text-right">
            <v-btn @click="saveProfile" :loading="loading" class="ma-2" tilte   color="success" dark>Сохранить</v-btn>
          </div>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  import {mapGetters} from 'vuex'

  export default {
    created() {
      let user = this.$store.getters['auth/getUser']
      for(let property in user){
          this.data[property] = user[property];
      }
    },
    data() {
      return {
        needConfirmPhoneNumber: false,
        errors : [],
        loading : false,
        data: {
          firstName: null,
          lastName: null,
          email: null,
          emailVerified: null,
          phoneNumber: null,
          phoneNumberActive: null,
          token : null,
        }
      }
    },
    methods:{
      saveProfile(){
        let data = this.data;
        this.errors = [];
        this.loading = true;
        bus.$emit('onProgressLinear');
        this.$store.dispatch('auth/updateProfile', data).then(({data}) => {
          this.token = null;
          bus.$emit('notificationAlert',{
            text : 'Сохранение прошло успешно',
            color: '#3d97f3'
          });
          bus.$emit('offProgressLinear');
          this.loading = false;
          if(data.needConfirmPhoneNumber){
            this.needConfirmPhoneNumber = true;
            bus.$emit('notificationAlert',{
              text : 'Вы изменили телефон, пожалуйста подтвердите его',
              color: '#4e98a6'
            });
          }

          if(data.token){
            this.errors['token'] = data.token;
            bus.$emit('notificationAlert',{
              text : 'Возникли ошибки',
              color: '#e35139'
            });
          }

          if(data.succeedChangeContact){
            bus.$emit('notificationAlert',{
              text : 'Телефон успешно изменён',
              color: '#3d97f3'
            });
            this.token = null;
            this.needConfirmPhoneNumber = false;
          }

          auth.getUser();
        }).catch((error) => {
          bus.$emit('notificationAlert',{
            text : 'Возникли ошибки',
            color: '#e35351'
          });
          this.loading = false;
          bus.$emit('offProgressLinear');
          let response = error.response

          if(response.status == 422){
            this.errors = response.data.errors;
          }
        });
      }
    }
  }
</script>
